import moment from 'moment-timezone';

// TODO: This all works, but is it backwards an even number of times, or something?
export function timezone_diff(from_tz: string, to_tz: string) {
    var from_tz_offset = moment().tz(from_tz).utcOffset() // offsets in minutes
    var to_tz_offset = moment().tz(to_tz).utcOffset()
    var diff = from_tz_offset - to_tz_offset

    var hours: number = Math.floor(diff/60)
    var hours_str: string = (hours<0?"":"+") + hours
    var minutes: number = Math.abs(diff%60)

    var to_tz_date = moment.tz(to_tz).format('YYYY-MM-DD')
    var from_tz_date = moment.tz(from_tz).format('YYYY-MM-DD')
    var day_str
    if(moment(from_tz_date).isBefore(to_tz_date)) {
      day_str = "Yesterday"
    } else if(moment(from_tz_date).isSame(to_tz_date)) {
      day_str = "Today"
    } else {
      day_str = "Tomorrow"
    }

    if(minutes === 0) {
      if(hours === 1 || hours === -1) {
        return day_str + ", " + hours_str + "HR"
      } else {
        return day_str + ", " + hours_str + "HRS"
      }
    } else {
      return day_str + ", " + (hours_str + ":" + minutes.toString().padStart(2, '0'))
    }
  }